/**
 * 邀请码管理器
 * 负责管理邀请码，提供获取、更新、验证等功能
 * @author 杨俊朗
 */
export class IamVerifyCodeManager {
  private static instance: IamVerifyCodeManager;
  private store: string = "";

  private constructor() {}

  // 单例模式
  public static getInstance(): IamVerifyCodeManager {
    if (!IamVerifyCodeManager.instance) {
      IamVerifyCodeManager.instance = new IamVerifyCodeManager();
    }
    return IamVerifyCodeManager.instance;
  }

  // 更新邀请码
  public update(value: string): void {
    console.log("update verify code store", value, import.meta.url);
    this.store = value;
  }

  // 获取邀请码
  public get(): string {
    return this.store;
  }

  // 清除邀请码
  public clear(): void {
    this.update("");
  }
}

export const iamVerifyCodeManager = IamVerifyCodeManager.getInstance();
